export enum LenderResponseTypeEnum {
  UNCONDITIONAL_BID = "UNCONDITIONAL_BID",
  CONDITIONAL_BID = "CONDITIONAL_BID",
}

export enum LenderResponseBenefitTypeEnum {
  NO_ADDITIONS_REQUIRED = "NO_ADDITIONS_REQUIRED",
  REDUCED_GUARANTOR_COMMITMENT = "REDUCED_GUARANTOR_COMMITMENT",
  NO_GUARANTOR_REQUIRED = "NO_GUARANTOR_REQUIRED",
  FREE_EARLY_PAYMENT = "FREE_EARLY_PAYMENT",
  NO_LEASING_DOWN_PAYMENT = "NO_LEASING_DOWN_PAYMENT",
  NO_LIMIT_FEE = "NO_LIMIT_FEE",
  NO_SETUP_FEE = "NO_SETUP_FEE",
  EU_LOAN = "EU_LOAN",
  NO_WITHDRAWAL_FEE = "NO_WITHDRAWAL_FEE",
}

export enum AmortizationMethodEnum {
  ANNUITY = "ANNUITY",
  LINEAR = "LINEAR",
  FIXED = "FIXED",
  BULLET = "BULLET",
  BUILDING_CREDIT = "BUILDING_CREDIT",
}

export enum FieldRequestFieldEnum {
  requested_amount = "requested_amount",
  repayment_time = "repayment_time",
  self_estimated_historic_revenue = "self_estimated_historic_revenue",
  self_estimated_revenue = "self_estimated_revenue",
  guarantors = "guarantors",
  accounting_data = "accounting_data",
  banking_data = "banking_data",
  property = "property",
  property_additional_data = "property_additional_data",
  unpaid_invoices = "unpaid_invoices",
  unpaid_invoices_additional_data = "unpaid_invoices_additional_data",
  company_mortgage = "company_mortgage",
  additional_securities = "additional_securities",
  budget = "budget",
  suggested_amount = "suggested_amount",
  pawned_invoices = "pawned_invoices",
  parent_company_guarantee = "parent_company_guarantee",
  share_mortgage = "share_mortgage",
  refinancing = "refinancing",
  sale_of_property = "sale_of_property",
  property_cash_flow = "property_cash_flow",
  construction_completed_repayment = "construction_completed_repayment",
  construction_estimate = "construction_estimate",
  building_permit = "building_permit",
  grouped_real_estate_collateral = "grouped_real_estate_collateral",
  grouped_real_estate_repayment = "grouped_real_estate_repayment",
  refinancing_amounts = "refinancing_amounts",
  leasing = "leasing",
  leasing_additional_data = "leasing_additional_data",
  reason = "reason",
  reason_explanation = "reason_explanation",
  additional_information = "additional_information",
  annual_report = "annual_report",
}

export enum FieldRequestTypeEnum {
  COLLATERAL = "COLLATERAL",
  ADDITIONAL_INFORMATION = "ADDITIONAL_INFORMATION",
}

export enum LenderApplicationTypeEnum {
  FAILED_LENDER_APPLICATION_FILTER = "FAILED_LENDER_APPLICATION_FILTER",
  NO_LENDER_RESPONSES = "NO_LENDER_RESPONSES",
  HAS_LENDER_RESPONSES = "HAS_LENDER_RESPONSES",
  REJECTED = "REJECTED",
  THIS_LENDER_APPLICATION_BID_SELECTED = "THIS_LENDER_APPLICATION_BID_SELECTED",
  OTHER_LENDER_APPLICATION_BID_SELECTED = "OTHER_LENDER_APPLICATION_BID_SELECTED",
  THIS_LENDER_APPLICATION_PAYOUT_RECEIVED_BY_CUSTOMER = "THIS_LENDER_APPLICATION_PAYOUT_RECEIVED_BY_CUSTOMER",
  OTHER_LENDER_APPLICATION_PAYOUT_RECEIVED_BY_CUSTOMER = "OTHER_LENDER_APPLICATION_PAYOUT_RECEIVED_BY_CUSTOMER",
}

export enum LenderApplicationsFilterEnum {
  NEW = "new",
  NO_COMPANY_LOAN_BIDS = "no_company_loan_bids",
  NO_INVOICE_PURCHASE_BIDS = "no_invoice_purchase_bids",
  NO_REAL_ESTATE_BIDS = "no_real_estate_bids",
  NO_LEASING_BIDS = "no_leasing_bids",
  HAS_OWN_BIDS = "has_own_bids",
  BID_SELECTED = "bid_selected",
  PAID_OUT = "paid_out",
  REJECTED = "rejected",
}

export enum LoanApplicationStateEnum {
  DRAFT = "DRAFT",
  CREATED = "CREATED",
  REJECTED = "REJECTED",
  ADVICE = "ADVICE",
  OPEN_FOR_BIDS = "OPEN_FOR_BIDS",
  NO_BIDS_RECEIVED = "NO_BIDS_RECEIVED",
  BIDS_REJECTED_BY_CUSTOMER = "BIDS_REJECTED_BY_CUSTOMER",
  BID_SELECTED = "BID_SELECTED",
  PAYOUT_RECEIVED_BY_CUSTOMER = "PAYOUT_RECEIVED_BY_CUSTOMER",
}

export enum RejectedByLenderReasonEnum {
  CUSTOMER_REASON = "CUSTOMER_REASON",
  LENDER_DECISION = "LENDER_DECISION",
}

export enum ProductEnum {
  COMPANY_LOAN = "COMPANY_LOAN",
  FACTORING = "FACTORING",
  REAL_ESTATE = "REAL_ESTATE",
  LEASING = "LEASING",
}

export enum BidTypeEnum {
  COMPANY_LOAN = "COMPANY_LOAN",
  FACTORING = "FACTORING",
  REAL_ESTATE = "REAL_ESTATE",
  LEASING = "LEASING",
  REVOLVING_CREDIT = "REVOLVING_CREDIT",
  PURCHASE_FINANCING = "PURCHASE_FINANCING",
}

export const PrimaryBidTypeByProduct: Record<ProductEnum, BidTypeEnum> = {
  [ProductEnum.COMPANY_LOAN]: BidTypeEnum.COMPANY_LOAN,
  [ProductEnum.FACTORING]: BidTypeEnum.FACTORING,
  [ProductEnum.REAL_ESTATE]: BidTypeEnum.REAL_ESTATE,
  [ProductEnum.LEASING]: BidTypeEnum.LEASING,
} as const;

export enum LeasingBidTypeEnum {
  LEASING = "LEASING",
  RENT = "RENT",
}

export enum LenderUserRoleEnum {
  ADMIN = "ADMIN",
  CREDIT_OFFICER = "CREDIT_OFFICER",
  DEVELOPER = "DEVELOPER",
}

export enum OnboardingStepEnum {
  ONBOARDING_STARTED = "ONBOARDING_STARTED",
  CREDIT_ASSESSMENT_DONE = "CREDIT_ASSESSMENT_DONE",
}

export enum HighlightedQualityEnum {
  INTEREST_RATE = "INTEREST_RATE",
  AMOUNT = "AMOUNT",
  INTEREST_RATE_AND_AMOUNT = "INTEREST_RATE_AND_AMOUNT",
}

export enum OfferAttractivenessRecommendationStatusEnum {
  LOWER_COMPARABLE_INTEREST_RATE = "LOWER_COMPARABLE_INTEREST_RATE",
  INCREASE_AMOUNT = "INCREASE_AMOUNT",
  INCREASE_REPAYMENT_TIME = "INCREASE_REPAYMENT_TIME",
}
